module.exports = __webpack_public_path__ + "img/20.dfeb30e7.jpg";